<template>
  <div>
    <vx-card class="mb-base">
      <div>
        <div class="vx-row">
          <div class="vx-col w-1/2 mt-2 mb-2 flex">
            <vx-card>
              <div class="vx-row">
                <div class="vx-col w-full mt-2 mb-2 flex">
                  <vs-select
                    autocomplete
                    class="w-full"
                    name="patient"
                    placeholder="Cari Pasien (No MR/Nama/Tgl Lahir/)"
                    v-validate="'required'"
                    v-model="patient"
                    >
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listPatient" />
                  </vs-select>
                </div>
              </div>

              <vs-divider position="center">
               Data Pasien
              </vs-divider>

               <vs-row class="mt-4">
                 <vs-col class="w-full flex">
                    <vs-input disabled name="patientName" label="Nama Lengkap Pasien" class="w-1/2" v-model="patientName" />
                    <vs-input disabled name="patientMR" label="No MR" class="w-1/4 ml-4" v-model="patientMR" />
                    <vs-input disabled name="ward" label="Lokasi" class="w-1/4 ml-4" v-model="ward" />
                 </vs-col>
               </vs-row>
               <vs-row class="mt-4">
                 <vs-col class="w-1/4">
                    <label for="patientBirthdate" class="vs-input--label">Tgl Lahir</label>
                    <datepicker disabled class="w-3/4" name="patientBirthdate" format="dd-MMM-yyyy" v-model="patientBirthdate"></datepicker>
                 </vs-col>
                 <vs-col class="w-1/4 flex">
                    <vs-input disabled name="patientAge" label="Umur" v-model="patientAge" class="w-1/2" />
                    <label class="vs-input--label mt-8">Tahun</label>
                 </vs-col>
                 <vs-col class="w-1/2 flex">
                    <vs-radio disabled v-model="patientSex" vs-name="patientSex" vs-value="L" class="ml-6 mr-6 mt-6">Laki-Laki</vs-radio>
                    <vs-radio disabled v-model="patientSex" vs-name="patientSex" vs-value="P" class="ml-6 mt-6">Perempuan</vs-radio>
                 </vs-col>
               </vs-row>
            </vx-card>
          </div>
          <div class="vx-col w-1/2 mt-2 mb-2 flex">
           <vx-card>
             <div class="vx-row">
               <div class="vx-col w-1/3 mt-2 mb-2 flex">
                  <label for="testDate" class="vs-input--label vs-dialog-text">Tgl Test SWAB</label>
               </div>
               <div class="vx-col w-1/2 mt-2 mb-2 flex">
                  <datepicker class="w-full" name="testDate" format="dd-MMM-yyyy" v-model="testDate"></datepicker>
               </div>
             </div>
             <div class="vx-row">
               <div class="vx-col w-1/3 mt-2 mb-2 flex">
                  <label for="labRef" class="vs-input--label vs-dialog-text">Lab Referensi</label>
               </div>
               <div class="vx-col w-2/3 mt-2 mb-2 flex">
                 <vs-select
                   autocomplete
                   class="w-full"
                   name="labRef"
                   placeholder="Lab Reference"
                   v-model="labRef"
                   >
                   <vs-select-item :key="index" :value="item.id" :text="item.name+' ('+item.code+')'" v-for="(item,index) in listLabRef" />
                 </vs-select>
               </div>
             </div>
             <div class="vx-row">
               <div class="vx-col w-1/3 mt-2 mb-2 flex">
                  <label for="testSwabKe" class="vs-input--label vs-dialog-text">Test SWAB Ke</label>
               </div>
               <div class="vx-col w-1/4 mt-2 mb-2 flex">
                 <vs-select
                   autocomplete
                   class="w-full"
                   name="testSwabKe"
                   placeholder="Test SWAB Ke"
                   v-model="testSwabKe"
                   >
                   <vs-select-item :key="index" :value="item" :text="item" v-for="(item,index) in ['1', '2', '3', '4', '5', '6']" />
                 </vs-select>
               </div>
             </div>
             <div class="vx-row">
               <div class="vx-col w-1/3 mt-2 mb-2 flex">
                  <label for="resSwab" class="vs-input--label vs-dialog-text">Hasil Test SWAB</label>
               </div>
               <div class="vx-col w-1/2 mt-2 mb-2 flex">
                  <vs-radio v-model="resSwab" vs-name="resSwab" vs-value="Positive" class="mr-6">
                     <label style="font-weight:bold; color:red">POSITIF</label>
                  </vs-radio>
                  <vs-radio v-model="resSwab" vs-name="resSwab" vs-value="Negative" class="ml-6">NEGATIF</vs-radio>
               </div>
             </div>
           </vx-card>
         </div>
        </div>
      </div>
    </vx-card>
    <div class="vx-col w-full">
      <div class="flex flex-end items-start mb-4">
        <vs-button
          class="mr-4 mb-4"
          color="danger"
          @click="$router.push('/customer').catch(() => {})"
          >
          Batal
        </vs-button>
        <vs-button
          class="mr-4 mb-4"
          icon-pack="feather"
          @click="onConfirm"
          >
          Simpan
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios.js';
import Datepicker from 'vuejs-datepicker';

export default {
  data() {
    return {
      patient: '',
      patientName: '',
      patientMR: '',
      ward: '',
      patientBirthdate: null,
      patientAge: 0,
      patientSex: null,
      testDate: new Date(),
      labRef: null,
      testSwabKe: 1,
      resSwab: 'Negative',
      listPatient: [],
      listLabRef: [
        {
          id: 1,
          code: 'BBLK',
          name: 'BBLK Jakarta',
        },
        {
          id: 2,
          code: 'RSPJ',
          name: 'RSPJ',
        },
        {
          id: 3,
          code: 'RSDC',
          name: 'RSDC Wisma Atlet',
        },
        {
          id: 4,
          code: 'FKUI',
          name: 'Mikro FKUI',
        },
        {
          id: 5,
          code: 'KALGEN',
          name: 'Kalgen',
        },
        {
          id: 7,
          code: 'EIJKMAN',
          name: 'Eijkman Institute for Molecular Biology',
        },
        {
          id: 8,
          code: 'BPOM',
          name: 'BPOM',
        }
      ]
    }
  },
  components: {
    Datepicker
  },
  methods: {
    onConfirm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          // if form have no errors
          this.$vs.dialog({
              type: 'confirm',
              color: 'warning',
              title: `Confirm`,
              text: 'Are you sure want to submit your data ?',
              acceptText: 'Yes',
              cancelText: 'No',
              accept: this.submitData
          });
        } else {
          // form have errors
          this.$vs.notify({
            title:'Error',
            time:4000,
            text:'Sorry, your data cannot be submited, some mandatory field may not empty. Please check again',
            color:'danger',
            position:'top-right'
          })
        }
      });
    },
    submitData() {
    }
  },
  created() {
    axios
        .get('/patient/list')
        .then(response => {
            this.listPatient = response.data.data;
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => this.loading = false);
  }
}
</script>

<style lang="scss" scoped>
.bordered {
  border-width: 1px;
  border-radius: 4px;
  box-shadow: 0 3px 10px 0 rgba(0,0,0,.15);
  margin: 0
}
.vx-custom-remove-icon {
  text-align: right;
}
.vs-textarea-primary.focusx {
  border: 1px solid #0056a8!important;
  box-shadow: 0 3px 10px 0 rgba(0,0,0,.15);
}
.vs-checkbox-default {
  transform: translate(0, -70%);
  top: 70%;
}
</style>
